export default class Beneficiary {
  /**
   * Create new business and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }

  get beneficiaryName () {
    return this.companyName ? this.companyName : [this.firstName, this.middleName, this.lastName].filter(Boolean).join(' ')
  }

  /**
   * @return {Date}
   */
  get dateOfBirth () {
    return this._dateOfBirth
  }

  /**
   * @param {string} value
   */
  set dateOfBirth (value) {
    this._dateOfBirth = value ? new Date(value) : null
  }
}
